module.exports = "../study/imgs/maps/Kanagawa/S8/WaterEnvironment/Chlave/Kanagawa_Chlave_HadGEM2_RCP26_End.png";